export enum BonusRuleValueType {
  FIX = "FIX",
  FACTOR = "FACTOR",
  PER_CENT = "FACTOR100",
}
